const settings = {
  tokenRefreshTimeMs: (1000 * 60) * 1 // 1min
}

export default settings
